import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { formatMoney } from '../../utils/format/format';

const ContributionsTable = ({ contributions }: any) => {
  console.log('Contrubutions', contributions);

  return (
    <Table sx={{ direction: 'ltr' }}>
      <TableBody>
        <TableRow sx={{ width: '100%', borderBottom: '1px solid #ddd' }}>
          <Table sx={{ borderCollapse: 'collapse', tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: 'calc((100% - 70px) / 2)',
                  }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    עובד
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: 'calc((100% - 70px) / 2)',
                  }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    מעסיק
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: '70px',
                  }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                 
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="2"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="3"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                    <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    תגמולים
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'900'}
                    fontSize={'14px'}
                    fontFamily={'Montserrat'}
                  >
                    <ContributionTableItem
                      contributions={contributions}
                      type="2"
                      exempt
                    />
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'900'}
                    fontSize={'14px'}
                    fontFamily={'Montserrat'}
                  >
                    <ContributionTableItem
                      contributions={contributions}
                      type="3"
                      exempt
                    />
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    פטורים
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="5"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="6"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: '70px',
                  }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    א.כ.ע
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="7"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                 <ContributionTableItem
                    contributions={contributions}
                    type="8"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: '70px',
                  }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    שונות
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableRow>
        <TableRow sx={{ width: '100%', borderBottom: '1px solid #ddd' }}>
          <Table sx={{ borderCollapse: 'collapse', tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: 'calc((100% - 70px) / 2)',
                  }}
                >
                  
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: 'calc((100% - 70px) / 2)',
                  }}
                >
           
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '4px',
                    width: '70px',
                  }}
                >
                  
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'900'}
                    fontSize={'14px'}
                    fontFamily={'Montserrat'}
                  >
                    -
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="1"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                ><Typography
                fontWeight={'700'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
              >
                פיצויים
              </Typography></TableCell>
              </TableRow>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'900'}
                    fontSize={'14px'}
                    fontFamily={'Montserrat'}
                  >
                    -
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'900'}
                    fontSize={'14px'}
                    fontFamily={'Montserrat'}
                  >
                    <ContributionTableItem
                    contributions={contributions}
                    type="1"
                    exempt
                  />
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'700'}
                    fontSize={'12px'}
                    fontFamily={'AlmoniDL'}
                  >
                    פטורים
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ border: 'none' }}>
                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <ContributionTableItem
                    contributions={contributions}
                    type="4"
                  />
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                >
                  <Typography
                    fontWeight={'900'}
                    fontSize={'14px'}
                    fontFamily={'Montserrat'}
                  >
                    -
                  </Typography>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ fontWeight: 'bold', border: 'none', padding: '4px' }}
                ><Typography
                fontWeight={'700'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
              >
                תגמולים 47
              </Typography></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableRow>
      </TableBody>
    </Table>
  );
};

const ContributionTableItem = ({ contributions, type, exempt }: any) => {
  const calculateContributionTotal = (
    contributions: any[],
    type: string,
    rate: boolean,
  ): number => {
    let total = 0;

    contributions?.forEach((contributionObj) => {
      if (contributionObj.contributionType?.toString() === type) {
        const amount = parseFloat(contributionObj.contributionAmount) || 0;

        if (rate) {
          const rateValue = parseFloat(contributionObj.contributionRate) || 0;
          total += amount * (rateValue / 100);
        } else {
          total += amount;
        }
      }
    });

    return total;
  };

  const getContributionRate = (contributions: any[], type: string): number => {
    const contribution = contributions?.find(
      (c) => c.contributionType?.toString() === type,
    );
    return contribution ? parseFloat(contribution.contributionRate) || 0 : 0;
  };

  const getExemptPayment = (contributions: any[], type: string): number => {
    const contribution = contributions?.find(
      (c) => c.contributionType?.toString() === type,
    );
    return contribution ? parseFloat(contribution.exemptPayments) || 0 : 0;
  };

  const formatPercentage = (value: number): string => {
    return value === 0 ? '-' : `${value.toFixed(2)}%`;
  };

  const formatValue = (value: number): string => {
    return value === 0 ? '-' : formatMoney(value);
  };

  if (exempt) {
    const exemptAmount = getExemptPayment(contributions, type);
    return (
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={1}
      >
        <Typography
          fontWeight={'900'}
          fontSize={'14px'}
          fontFamily={'Montserrat'}
        >
          {formatValue(exemptAmount)}
        </Typography>
      </Stack>
    );
  }

  const rate = getContributionRate(contributions, type);
  const total = calculateContributionTotal(contributions, type, false);

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      spacing={1}
    >
      {rate !== 0 && (
        <Box
          sx={{
            borderRadius: '30px',
            px: '15px',
            py: '5px',
            backgroundColor: '#F2F4F7',
          }}
        >
          <Typography
            fontWeight={'900'}
            fontSize={'14px'}
            fontFamily={'Montserrat'}
          >
            {formatPercentage(rate)}
          </Typography>
        </Box>
      )}
      <Typography
        fontWeight={'900'}
        fontSize={'14px'}
        fontFamily={'Montserrat'}
      >
        {formatValue(total)}
      </Typography>
    </Stack>
  );
};

export default ContributionsTable; 